/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gallery_OfflineInputs */

const en_us2_gallery_offline = /** @type {(inputs: Gallery_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect to the internet to see the gallery.`)
};

const pt_br2_gallery_offline = /** @type {(inputs: Gallery_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conecte-se à internet para ver a galeria.`)
};

const pt_pt2_gallery_offline = /** @type {(inputs: Gallery_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conecte-se à internet para ver a galeria.`)
};

/** @type {(inputs: Gallery_OfflineInputs) => LocalizedString} */
const es_419_gallery_offline = en_us2_gallery_offline;

/** @type {(inputs: Gallery_OfflineInputs) => LocalizedString} */
const fr_fr2_gallery_offline = en_us2_gallery_offline;

/** @type {(inputs: Gallery_OfflineInputs) => LocalizedString} */
const de_de2_gallery_offline = en_us2_gallery_offline;

/** @type {(inputs: Gallery_OfflineInputs) => LocalizedString} */
const it_it2_gallery_offline = en_us2_gallery_offline;

/**
* | output |
* | --- |
* | "Connect to the internet to see the gallery." |
*
* @param {Gallery_OfflineInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const gallery_offline = /** @type {((inputs?: Gallery_OfflineInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gallery_OfflineInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_gallery_offline(inputs)
	if (locale === "es-419") return es_419_gallery_offline(inputs)
	if (locale === "pt-PT") return pt_pt2_gallery_offline(inputs)
	if (locale === "fr-FR") return fr_fr2_gallery_offline(inputs)
	if (locale === "de-DE") return de_de2_gallery_offline(inputs)
	if (locale === "it-IT") return it_it2_gallery_offline(inputs)
	return en_us2_gallery_offline(inputs)
});
export { gallery_offline as "gallery.offline" }